import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { AgGridSalesDepot } from "../../components/budget/sales-depot/AgGridSalesDepot";
import { _ROUTES } from "../../utils/_routes_constants";
import { _ACTIVITIES, _ROLES_BACK, TYPE_SITE } from "../../utils/constants";
import { useEffect, useState } from "react";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import {
  LINKED_DEPOT_DATA,
  SAVE_CATEGORY_SALES_DEPOT,
} from "../../utils/constantsSave";

export default function InputSalesDepot() {
  const [saveData, setSaveData] = useState([]);
  const arrayData = LINKED_DEPOT_DATA;
  const save_name_category = SAVE_CATEGORY_SALES_DEPOT;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData
        ?.map((d) => {
          if (!d) return null;

          const payload = {
            activityName: _ACTIVITIES.AGG,
            siteId: params.site,
            theme: d.rowName,
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d[i] || null;
          }

          return payload;
        })
        .filter(
          (d) =>
            d !== null &&
            (d.theme === "External Volumes" || d.theme === "Internal Volumes"),
        );

      sendToFinancialData(modifiedData, save_name_category);
    }
  }, [saveData]);

  return (
    <>
      <BaseBudgetInput
        title="Input Sales Depot"
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
        userRole={_ROLES_BACK._ROLE_SALES}
        enableFlag="dataEntryEnableSales"
        TableComponent={AgGridSalesDepot}
        tableComponentProps={{
          params,
        }}
        saveData={saveData}
        setSaveData={setSaveData}
        includeBaseBudgetSave={true}
        arrayData={arrayData}
        saveNameCategory={save_name_category}
        onParamsChange={setParams}
        filters={[
          {
            key: "site",
            route: _ROUTES.SITES,
            defaultValue: "",
            label: "Site",
            queryParams: {
              active: 1,
              type: TYPE_SITE.DEPOT,
            },
          },
        ]}
      />
    </>
  );
}
